import React, { memo, NamedExoticComponent, ChangeEvent } from 'react'
import { IPhoneInputProps } from 'transfix-ui/components/PhoneInput'
import { ICarrierReference } from 'types/carrier'
import {
  ITextInputField,
  IPhoneInputField,
  validInputTypes,
  components,
} from 'apps/carrier/constants/carrierReferences'
import { ITextInputProps } from 'components/atoms'

interface IReferenceEntryForm {
  type: string
  reference: ICarrierReference
  inputChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const ReferenceEntryForm = memo<IReferenceEntryForm>(({ inputChange, reference, type }) => {
  const {
    companyName,
    companyValidation,
    contactName,
    email,
    phone,
    phoneValidation,
    uuid,
  } = reference
  const isAdd = type === 'add'
  const idAttributes = {
    contactName: isAdd ? 'contactName' : `${uuid}:contactName`,
    companyName: isAdd ? 'companyName' : `${uuid}:companyName`,
    phone: isAdd ? 'phone' : `${uuid}:phone`,
    email: isAdd ? 'email' : `${uuid}:email`,
  }
  const inputFields: (ITextInputField | IPhoneInputField)[] = [
    {
      type: 'text',
      placeholder: 'Company Name',
      label: 'Company Name',
      value: companyName || '',
      onChange: inputChange,
      id: idAttributes.companyName,
      dataTest: 'company-name',
      invalid: Boolean(companyValidation),
      validationMessage: companyValidation,
      required: true,
      colSize: 'col-xs-6',
    },
    {
      type: 'text',
      placeholder: 'Jane Doe',
      label: 'Contact Name',
      value: contactName || '',
      onChange: inputChange,
      id: idAttributes.contactName,
      dataTest: 'contact-name',
      colSize: 'col-xs-6',
    },
    {
      type: 'phone',
      placeholder: '(555) 555-5555',
      label: 'Phone',
      value: phone || '',
      onChange: inputChange,
      id: idAttributes.phone,
      dataTest: 'phone',
      required: true,
      invalid: Boolean(phoneValidation),
      validationMessage: phoneValidation,
      colSize: 'col-xs-3',
    },
    {
      type: 'text',
      placeholder: 'Email',
      label: 'Email',
      value: email || '',
      onChange: inputChange,
      id: idAttributes.email,
      dataTest: 'email',
      colSize: 'col-xs-6',
    },
  ]

  return (
    <>
      {inputFields.map((field: ITextInputField | IPhoneInputField) => {
        const fieldType = field.type as validInputTypes
        let Component = components[fieldType]
        const { colSize, ...props } = field
        let returnComponent
        if (fieldType === validInputTypes.TEXT) {
          Component = Component as NamedExoticComponent<ITextInputProps>
          // eslint-disable-next-line react/jsx-props-no-spreading
          returnComponent = <Component {...(props as ITextInputField)} />
        } else {
          Component = Component as NamedExoticComponent<IPhoneInputProps>
          // eslint-disable-next-line react/jsx-props-no-spreading
          returnComponent = <Component {...(props as IPhoneInputField)} />
        }
        return (
          <div className={colSize} key={field.id}>
            {returnComponent}
          </div>
        )
      })}
    </>
  )
})

export default ReferenceEntryForm
